import { render, staticRenderFns } from "./MultiInput.vue?vue&type=template&id=8677e5ae&scoped=true"
import script from "./MultiInput.vue?vue&type=script&lang=ts"
export * from "./MultiInput.vue?vue&type=script&lang=ts"
import style0 from "./MultiInput.vue?vue&type=style&index=0&id=8677e5ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8677e5ae",
  null
  
)

export default component.exports